<div class="main-container">
  <p *ngIf="sentSuccessfully">
    Success.
  </p>
  Add New Link
  <div [formGroup]="linkForm">
    <div>
      Name
      <input placeholder="name" type="text" formControlName="name">
  </div>
  <div>
    URL
    <input placeholder="url of link" type="text" formControlName="url">
  </div>
  <div>
    Image
    <input #inputFile type="file" accept="image/*" (change)="handleFileInput($event)">
  </div>
 

 
    <button [disabled]="linkForm.invalid" (click)="sendForm()">Submit</button>
  
  </div>